<!--
 * @Description:
 * @Author: Ingyi
 * @Date: 2021-09-02 15:51:56
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-02 16:24:55
-->
<template>
  <div class="login-page">
    <div class="login-content">
      <div class="login-form">
        <h2 style="text-align: center">用户登录</h2>
        <a-form
          :form="form"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-form-item
            label="用户名"
            label-width="50px"
            style="text-align: justify; text-align-last: justify"
          >
            <a-input
              v-decorator="[
                'username',
                { rules: [{ required: true, message: '请输入用户名!' }] },
              ]"
              style="width: 240px; text-align: left; text-align-last: left"
            />
          </a-form-item>
          <a-form-item
            label="密 码"
            style="text-align: justify; text-align-last: justify"
          >
            <a-input
              type="password"
              v-decorator="[
                'password',
                { rules: [{ required: true, message: '请输入密码!' }] },
              ]"
              style="width: 240px; text-align: left; text-align-last: left"
            />
          </a-form-item>

          <a-form-item
            label="验证码"
            style="
              position: relative;
              text-align: justify;
              text-align-last: justify;
            "
          >
            <a-input
              type="code"
              v-decorator="[
                'code',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入验证码!',
                      style: 'text-align-last: left',
                    },
                  ],
                },
              ]"
              style="
                width: 140px;
                flex: 1;
                text-align: left;
                text-align-last: left;
              "
            />
            <img
              style="
                width: 80px;
                height: 30px;
                flex: 2;
                position: absolute;
                margin-left: 20px;
                border: 0.5px solid black;
                margin-top: 5px;
              "
              :src="
                '/newapp/api/client/login/captchaImage?attmentId=' +
                  param.attmentId
              "
              @click="codeshen()"
            />
          </a-form-item>

          <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
            <a-button type="primary" @click="handleSubmit" style="width: 240px">
              登录
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import request from '../util/request'
import { encrypt } from '@/util/jsencrypt'
export default {
  name: 'login',
  data() {
    return {
      form: this.$form.createForm(this, {}),
      param: {
        attmentId: Math.round(Math.random() * 5),
        username: '',
        password: '',
        code: '',
        nullSpace: '\t\t\t\t\t\t',
      },
    }
  },
  created() {
    request({
      url: '/api/client/login/judgmentTime',
      method: 'get',
    }).then((res) => {
      if (res.data == true) {
        this.$router.push('/404')
      }
    })
  },
  mounted() {
    let id = this.$route.query.url
    this.url = id
  },
  methods: {
    codeshen() {
      this.param.attmentId = Math.round(Math.random() * 5)
    },
    queryUserInfo() {},
    handleSubmit() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
        }
        values.attmentId = this.param.attmentId
        values.username = encrypt(values.username)
        values.password = encrypt(values.password)
        request({
          url: '/api/client/login/pc',
          method: 'post',
          params: values,
        }).then((res) => {
          console.log(res)
          if (res.code == '200') {
            console.log(this.url)
            localStorage.setItem('token', res.data.accessToken)
            request({
              url: '/api/tool/user/client/info',
            }).then((res) => {
              if (res.code == '200') {
                this.userInfo = res.data
                localStorage.setItem('userInfo', JSON.stringify(res.data))
                console.log(this.url)
                this.$emit('login')
                console.log('emit=====',res.data)
                if (typeof this.url == 'undefined') {
                  this.$router.push('/userCenter/Index')
                } else {
                  this.url = this.url.replace('#', '')
                  console.log(this.url)
                  this.$router.push(this.url)
                }
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
  },
}
</script>

<style lang="less">
.login-page {
  .banner {
    width: 100%;
    height: 140px;
    background: #ddd;

    .logo-box {
      width: 310px;
      height: 140px;
      background: #fff;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .login-content {
    background: url('../assets/img/loginbanner.jpg') !important;
    padding-top: 120px;
    height: 650px;
    display: flex;
    position: relative;
    .login-form {
      position: absolute;
      border-radius: 5px;
      right: 180px;
      margin: 20px;
      height: 350px;
      padding: 40px 20px;
      border: 1px solid #ccc;
      background: #fff;
    }
    .login-tips {
      flex: 1;
    }
  }
}
</style>
